import { lazy } from 'react';

const PayableVoucher = lazy(() => import('../pages/PayableVoucher'));
const PrintEWTFormBatch = lazy(() =>
  import('../pages/PayableVoucher/Screens/PrintEWTFormBatchScreen'),
);

const payableVoucherRoute = {
  public: [],
  auth: [
    // Must stay ahead of the `:id?` route below — otherwise the tab route
    // swallows this path as a tab name.
    {
      name: 'payable-voucher-print-ewt-form-batch',
      path: '/finance-and-accounting/payable-voucher/print-ewt-form-batch',
      component: PrintEWTFormBatch,
    },
    {
      name: 'payable-voucher',
      // `:pvId?` carries the record id for edit/draft mode
      // (e.g. /payable-voucher/edit/123) so a page refresh can reload it.
      path: '/finance-and-accounting/payable-voucher/:id?/:pvId?',
      component: PayableVoucher,
    },
  ],
};

export default payableVoucherRoute;
